// lib/themeTokens.ts
function applyFlat(obj, table, vars) {
  if (!obj) return;
  for (const { cssVar, key } of table) {
    const value = obj[key];
    if (value !== void 0) vars[cssVar] = value;
  }
}
var DENSITY_SPACING_VARS = [
  { cssVar: "--space-0", key: "space0" },
  { cssVar: "--space-1", key: "space1" },
  { cssVar: "--space-2", key: "space2" },
  { cssVar: "--space-3", key: "space3" },
  { cssVar: "--space-4", key: "space4" },
  { cssVar: "--space-5", key: "space5" },
  { cssVar: "--space-6", key: "space6" },
  { cssVar: "--space-7", key: "space7" },
  { cssVar: "--space-8", key: "space8" },
  { cssVar: "--space-9", key: "space9" },
  { cssVar: "--space-10", key: "space10" },
  { cssVar: "--space-11", key: "space11" },
  { cssVar: "--space-12", key: "space12" }
];
var DENSITY_ELEMENT_VARS = [
  { cssVar: "--button-height-sm", key: "buttonHeightSm" },
  { cssVar: "--button-height-md", key: "buttonHeightMd" },
  { cssVar: "--button-height-lg", key: "buttonHeightLg" },
  { cssVar: "--input-height-sm", key: "inputHeightSm" },
  { cssVar: "--input-height-md", key: "inputHeightMd" },
  { cssVar: "--input-height-lg", key: "inputHeightLg" },
  { cssVar: "--row-height-compact", key: "rowHeightCompact" },
  { cssVar: "--row-height-normal", key: "rowHeightNormal" },
  { cssVar: "--row-height-spacious", key: "rowHeightSpacious" },
  { cssVar: "--card-padding-sm", key: "cardPaddingSm" },
  { cssVar: "--card-padding-md", key: "cardPaddingMd" },
  { cssVar: "--card-padding-lg", key: "cardPaddingLg" },
  { cssVar: "--dialog-padding", key: "dialogPadding" },
  { cssVar: "--section-gap", key: "sectionGap" }
];
var TYPE_FAMILY_VARS = [
  { cssVar: "--font-family-display", key: "displayFamily" },
  { cssVar: "--font-family-body", key: "bodyFamily" },
  { cssVar: "--font-family-mono", key: "monoFamily" }
];
var TYPE_HEADING_VARS = [
  { cssVar: "--heading-weight", key: "headingWeight" },
  { cssVar: "--heading-transform", key: "headingTransform" },
  { cssVar: "--heading-tracking", key: "headingTracking" },
  { cssVar: "--heading-style", key: "headingStyle" },
  { cssVar: "--heading-shadow", key: "headingShadow" }
];
var TYPE_SIZE_KEYS = [
  "xs",
  "sm",
  "base",
  "lg",
  "xl",
  "2xl",
  "3xl",
  "4xl",
  "display-1",
  "display-2"
];
var TYPE_INTENT_VARS = [
  { key: "headingMajor", cssName: "heading-major" },
  { key: "headingMinor", cssName: "heading-minor" },
  { key: "bodyEmphasis", cssName: "body-emphasis" },
  { key: "bodyDefault", cssName: "body-default" },
  { key: "bodyQuiet", cssName: "body-quiet" },
  { key: "caption", cssName: "caption" },
  { key: "numeric", cssName: "numeric" }
];
var MOTION_DURATION_KEYS = [
  "instant",
  "fast",
  "normal",
  "slow",
  "dramatic"
];
var MOTION_EASING_KEYS = [
  "linear",
  "standard",
  "emphasized",
  "spring"
];
var MOTION_INTENT_VARS = [
  { key: "enter", cssName: "enter" },
  { key: "exit", cssName: "exit" },
  { key: "hover", cssName: "hover" },
  { key: "press", cssName: "press" },
  { key: "expand", cssName: "expand" },
  { key: "transition", cssName: "transition" }
];
var MOTION_SHAPE_VARS = [
  { cssVar: "--motion-modal-enter-from-transform", key: "modalEnter" },
  { cssVar: "--motion-modal-exit-to-transform", key: "modalExit" },
  { cssVar: "--motion-popover-enter-from-transform", key: "popoverEnter" },
  { cssVar: "--motion-popover-exit-to-transform", key: "popoverExit" },
  { cssVar: "--motion-toast-enter-from-transform", key: "toastEnter" },
  { cssVar: "--motion-toast-exit-to-transform", key: "toastExit" },
  { cssVar: "--motion-page-enter-from-transform", key: "pageEnter" },
  { cssVar: "--motion-enter-rise-from-transform", key: "enterRise" },
  { cssVar: "--motion-enter-scale-from-transform", key: "enterScale" },
  { cssVar: "--motion-enter-slide-from-transform", key: "enterSlide" }
];
var ICONOGRAPHY_VARS = [
  { cssVar: "--icon-family", key: "family" },
  { cssVar: "--icon-stroke-width", key: "strokeWidth" },
  { cssVar: "--icon-default-size", key: "defaultSize" }
];
var ELEVATION_VARS = [
  { cssVar: "--elevation-card", key: "cardElevation" },
  { cssVar: "--elevation-popover", key: "popoverElevation" },
  { cssVar: "--elevation-dialog", key: "dialogElevation" },
  { cssVar: "--elevation-toast", key: "toastElevation" },
  { cssVar: "--elevation-interactive", key: "interactiveElevation" },
  { cssVar: "--elevation-pressed", key: "pressedElevation" }
];
var GEOMETRY_VARS = [
  { cssVar: "--radius-container", key: "radiusContainer" },
  { cssVar: "--radius-interactive", key: "radiusInteractive" },
  { cssVar: "--radius-pill", key: "radiusPill" },
  { cssVar: "--border-hairline", key: "borderHairline" },
  { cssVar: "--border-standard", key: "borderStandard" },
  { cssVar: "--border-heavy", key: "borderHeavy" },
  { cssVar: "--corner-shape", key: "cornerShape" },
  { cssVar: "--corner-shape-pill", key: "cornerShapePill" },
  { cssVar: "--corner-shape-interactive", key: "cornerShapeInteractive" },
  { cssVar: "--border-style", key: "borderStyle" },
  { cssVar: "--border-style-interactive", key: "borderStyleInteractive" }
];
var SURFACE_VARS = [
  { cssVar: "--surface-backdrop", key: "backdrop" },
  { cssVar: "--surface-card-image", key: "cardImage" },
  { cssVar: "--surface-page-image", key: "pageImage" },
  { cssVar: "--surface-page-image-size", key: "pageImageSize" },
  { cssVar: "--surface-diagram", key: "diagram" },
  { cssVar: "--surface-edge-mask", key: "edgeMask" },
  { cssVar: "--surface-edge-height", key: "edgeHeight" },
  { cssVar: "--surface-texture-mask", key: "textureMask" },
  { cssVar: "--surface-texture-size", key: "textureSize" },
  { cssVar: "--surface-accent-image", key: "accentImage" },
  { cssVar: "--surface-scrim", key: "scrim" }
];
var DIAGRAM_VARS = [
  { cssVar: "--diagram-stroke-thin", key: "strokeThin" },
  { cssVar: "--diagram-stroke-normal", key: "strokeNormal" },
  { cssVar: "--diagram-stroke-bold", key: "strokeBold" },
  { cssVar: "--diagram-line-cap", key: "lineCap" },
  { cssVar: "--diagram-line-join", key: "lineJoin" },
  { cssVar: "--diagram-dash", key: "dash" },
  { cssVar: "--diagram-dot", key: "dot" },
  { cssVar: "--diagram-fill-style", key: "fillStyle" },
  { cssVar: "--diagram-fill-opacity", key: "fillOpacity" },
  { cssVar: "--diagram-roughness", key: "roughness" },
  { cssVar: "--diagram-glow", key: "glow" },
  { cssVar: "--diagram-shadow", key: "shadow" },
  { cssVar: "--diagram-marker", key: "marker" },
  { cssVar: "--diagram-label-font", key: "labelFont" },
  { cssVar: "--diagram-label-size", key: "labelSize" },
  { cssVar: "--diagram-label-weight", key: "labelWeight" },
  { cssVar: "--diagram-label-case", key: "labelCase" },
  { cssVar: "--diagram-corner", key: "corner" }
];
var SCENE_VARS = [
  { cssVar: "--material-roughness", key: "materialRoughness" },
  { cssVar: "--material-metalness", key: "materialMetalness" },
  { cssVar: "--material-flat", key: "materialFlat" },
  { cssVar: "--material-outline", key: "materialOutline" },
  { cssVar: "--light-ambient", key: "lightAmbient" },
  { cssVar: "--light-key", key: "lightKey" },
  { cssVar: "--light-key-color", key: "lightKeyColor" },
  { cssVar: "--scene-fog", key: "fog" }
];
var LEGACY_PREFIXES = {
  colors: "--color-",
  radii: "--radius-",
  spacing: "--space-",
  shadows: "--shadow-"
};
function themeTokensToCssVars(tokens, mode = "light", darkVariant) {
  const vars = {};
  const isDark = mode === "dark";
  const pickColors = isDark && darkVariant?.colors ? darkVariant.colors : tokens.colors;
  if (pickColors) {
    for (const [key, value] of Object.entries(pickColors)) {
      vars[`${LEGACY_PREFIXES.colors}${key}`] = value;
    }
    if (isDark && darkVariant?.colors && tokens.colors) {
      for (const [key, value] of Object.entries(tokens.colors)) {
        const varName = `${LEGACY_PREFIXES.colors}${key}`;
        if (!(varName in vars)) vars[varName] = value;
      }
    }
  }
  const pickRadii = isDark && darkVariant?.radii ? darkVariant.radii : tokens.radii;
  if (pickRadii) {
    for (const [key, value] of Object.entries(pickRadii)) {
      vars[`${LEGACY_PREFIXES.radii}${key}`] = value;
    }
  }
  const pickSpacing = isDark && darkVariant?.spacing ? darkVariant.spacing : tokens.spacing;
  if (pickSpacing) {
    for (const [key, value] of Object.entries(pickSpacing)) {
      vars[`${LEGACY_PREFIXES.spacing}${key}`] = value;
    }
  }
  const pickTypography = isDark && darkVariant?.typography ? darkVariant.typography : tokens.typography;
  if (pickTypography) {
    for (const [key, value] of Object.entries(pickTypography)) {
      vars[`--${key}`] = value;
    }
  }
  const pickShadows = isDark && darkVariant?.shadows ? darkVariant.shadows : tokens.shadows;
  if (pickShadows) {
    for (const [key, value] of Object.entries(pickShadows)) {
      vars[`${LEGACY_PREFIXES.shadows}${key}`] = value;
    }
  }
  const pickDensity = isDark && darkVariant?.density ? darkVariant.density : tokens.density;
  emitDensity(pickDensity, vars);
  const pickTypeScale = isDark && darkVariant?.typeScale ? darkVariant.typeScale : tokens.typeScale;
  emitTypeScale(pickTypeScale, vars);
  const pickMotion = isDark && darkVariant?.motion ? darkVariant.motion : tokens.motion;
  emitMotion(pickMotion, vars);
  const pickIconography = isDark && darkVariant?.iconography ? darkVariant.iconography : tokens.iconography;
  emitIconography(pickIconography, vars);
  const pickElevation = isDark && darkVariant?.elevation ? darkVariant.elevation : tokens.elevation;
  emitElevation(pickElevation, vars);
  const pickGeometry = isDark && darkVariant?.geometry ? darkVariant.geometry : tokens.geometry;
  emitGeometry(pickGeometry, vars);
  const pickSurface = isDark && darkVariant?.surface ? darkVariant.surface : tokens.surface;
  applyFlat(pickSurface, SURFACE_VARS, vars);
  const pickDiagram = isDark && darkVariant?.diagram ? darkVariant.diagram : tokens.diagram;
  applyFlat(pickDiagram, DIAGRAM_VARS, vars);
  const pickScene = isDark && darkVariant?.scene ? darkVariant.scene : tokens.scene;
  applyFlat(pickScene, SCENE_VARS, vars);
  return vars;
}
function emitDensity(density, vars) {
  if (!density) return;
  applyFlat(density.spacing, DENSITY_SPACING_VARS, vars);
  applyFlat(density, DENSITY_ELEMENT_VARS, vars);
}
function typeSizeKeyStr(k) {
  return k;
}
function typeWeightStr(w) {
  return w;
}
function emitTypeIntent(name, intent, vars) {
  const sizeKey = typeSizeKeyStr(intent.size);
  const weight = typeWeightStr(intent.weight);
  vars[`--intent-${name}-size`] = `var(--text-${sizeKey})`;
  vars[`--intent-${name}-weight`] = `var(--font-weight-${weight})`;
  vars[`--intent-${name}-leading`] = `var(--leading-${sizeKey})`;
}
function emitTypeScale(ts, vars) {
  if (!ts) return;
  applyFlat(ts, TYPE_FAMILY_VARS, vars);
  applyFlat(ts, TYPE_HEADING_VARS, vars);
  if (ts.scale) {
    const s = ts.scale;
    for (const k of TYPE_SIZE_KEYS) {
      const entry = s[k];
      if (entry !== void 0) {
        vars[`--text-${k}`] = entry.size;
        vars[`--leading-${k}`] = entry.lineHeight;
      }
    }
  }
  if (ts.intents) {
    const i = ts.intents;
    for (const { key, cssName } of TYPE_INTENT_VARS) {
      const intent = i[key];
      if (intent) emitTypeIntent(cssName, intent, vars);
    }
  }
}
function emitMotionIntent(name, intent, vars) {
  vars[`--intent-${name}-duration`] = `var(--duration-${intent.duration})`;
  vars[`--intent-${name}-easing`] = `var(--easing-${intent.easing})`;
}
function emitMotion(m, vars) {
  if (!m) return;
  if (m.durations) {
    const d = m.durations;
    for (const k of MOTION_DURATION_KEYS) {
      const v = d[k];
      if (v !== void 0) vars[`--duration-${k}`] = v;
    }
  }
  if (m.easings) {
    const e = m.easings;
    for (const k of MOTION_EASING_KEYS) {
      const v = e[k];
      if (v !== void 0) vars[`--easing-${k}`] = v;
    }
  }
  if (m.intents) {
    const i = m.intents;
    for (const { key, cssName } of MOTION_INTENT_VARS) {
      const intent = i[key];
      if (intent) emitMotionIntent(cssName, intent, vars);
    }
  }
  applyFlat(m.shapes, MOTION_SHAPE_VARS, vars);
  if (m.entry?.default !== void 0) vars["--motion-enter-default"] = enterKeyframe(m.entry.default);
  if (m.entry?.stagger !== void 0) vars["--motion-enter-stagger"] = m.entry.stagger;
  if (m.busyDelay !== void 0) vars["--motion-busy-delay"] = m.busyDelay;
  if (m.awaitingSkeleton !== void 0) vars["--awaiting-skeleton-display"] = m.awaitingSkeleton ? "block" : "none";
}
function enterKeyframe(enter) {
  return enter === "none" ? "none" : `almadar-enter-${enter}`;
}
function emitIconography(i, vars) {
  applyFlat(i, ICONOGRAPHY_VARS, vars);
}
function emitElevation(e, vars) {
  applyFlat(e, ELEVATION_VARS, vars);
}
function emitGeometry(g, vars) {
  applyFlat(g, GEOMETRY_VARS, vars);
}
function resolveThemeForRuntime(theme) {
  if (theme === void 0) return void 0;
  if (typeof theme === "string") return void 0;
  return theme;
}

export { DENSITY_ELEMENT_VARS, DENSITY_SPACING_VARS, DIAGRAM_VARS, ELEVATION_VARS, GEOMETRY_VARS, ICONOGRAPHY_VARS, LEGACY_PREFIXES, MOTION_DURATION_KEYS, MOTION_EASING_KEYS, MOTION_INTENT_VARS, MOTION_SHAPE_VARS, SCENE_VARS, SURFACE_VARS, TYPE_FAMILY_VARS, TYPE_HEADING_VARS, TYPE_INTENT_VARS, TYPE_SIZE_KEYS, enterKeyframe, resolveThemeForRuntime, themeTokensToCssVars };
